import React, { Component } from 'react';
import arrow from '../../assets/images/icons/arrow-left.svg';
import play from '../../assets/images/icons/play-icn.svg';
import { headers, api_url } from '../../common/config';
import { Link } from 'react-router-dom';
import Carousel, { consts } from 'react-elastic-carousel';
import i18next from 'i18next';
import windowSize from 'react-window-size';

const mediumBreakPoints = [
    { width: 1, itemsToShow: 1 },
    { width: 400, itemsToShow: 1 },
    { width: 650, itemsToShow: 2 },
    { width: 968, itemsToShow: 3 },
    { width: 1000, itemsToShow: 3 },
    { width: 1570, itemsToShow: 4 },
    { width: 1900, itemsToShow: 5 },
];

class Videos extends Component {
    constructor(props) {
        super(props);

        this.state = {
            videos: null,
        };
    }

    componentDidMount() {
        fetch(
            `${api_url}/autism/items/news_page_videos?filter[status]=published&fields=*.*`,
            {
                method: 'GET',
                // headers: headers,
            }
        )
            .then((res) => res.json())
            .then((res) => {
                this.setState({
                    videos: res.data,
                });
            });
    }

    myArrow({ type, onClick, isEdge }) {
        const pointer =
            type === consts.PREV ? (
                <img
                    src={arrow}
                    alt=''
                    style={{ transform: 'rotate(180deg)' }}
                />
            ) : (
                <img src={arrow} alt='' />
            );

        const en_pointer =
            type === consts.PREV ? (
                <img src={arrow} alt='' />
            ) : (
                <img
                    src={arrow}
                    alt=''
                    style={{ transform: 'rotate(180deg)' }}
                />
            );

        return (
            <>
                {i18next.language === 'ar' ? (
                    <button
                        onClick={onClick}
                        disabled={isEdge}
                        className='sliderBtn'
                    >
                        {pointer}
                    </button>
                ) : (
                    <button
                        onClick={onClick}
                        disabled={isEdge}
                        className='sliderBtn en_sliderBtn'
                    >
                        {en_pointer}
                    </button>
                )}
            </>
        );
    }

    noArrow() {
        return <></>;
    }

    render() {
        let cards = null;
        let videos = [''];
        if (this.state.videos === null) {
            cards = videos.map((vid) => (
                <div className='videos_card'>
                    <div className='play_button'>
                        {/* <img src={play} /> */}
                    </div>
                    <div className='video_details'>
                        <div className='video_title'></div>
                        <div className='video_duration'></div>
                    </div>
                </div>
            ));
        } else {
            cards = this.state.videos.map((vid) => (
                <Link to={`/media/video/${vid.id}`}>
                    <div
                        className='videos_card'
                        style={{
                            backgroundImage: `url(${vid.image.data.full_url})`,
                            backgroundSize: 'cover',
                            backgroundRepeat: 'no-repeat',
                            backgroundPosition: 'center',
                        }}
                    >
                        <div className='play_button'>
                            <img src={play} />
                        </div>
                        <div className='video_details'>
                            <div className='video_duration'></div>
                        </div>
                    </div>
                    {/* <div className='video_title'>
                        <h1>{vid.title}</h1>
                        <h4>#{vid.tags}</h4>
                    </div> */}
                </Link>
            ));
        }

        return (
            <div className='media-videos-container'>
                {this.props.windowWidth > 600 ? (
                    <>
                        {i18next.language === 'ar' ? (
                            <Carousel
                                breakPoints={mediumBreakPoints}
                                pagination={false}
                                isRTL={true}
                                itemPadding={[40, 15, 40, 15]}
                                renderArrow={this.myArrow}
                            >
                                {cards}
                            </Carousel>
                        ) : (
                            <Carousel
                                breakPoints={mediumBreakPoints}
                                pagination={false}
                                // isRTL={true}
                                itemPadding={[40, 15, 40, 15]}
                                renderArrow={this.myArrow}
                            >
                                {cards}
                            </Carousel>
                        )}
                    </>
                ) : (
                    <>
                        {i18next.language === 'ar' ? (
                            <Carousel
                                breakPoints={mediumBreakPoints}
                                pagination={false}
                                isRTL={true}
                                itemPadding={[40, 15, 40, 15]}
                                renderArrow={this.noArrow}
                            >
                                {cards}
                            </Carousel>
                        ) : (
                            <Carousel
                                breakPoints={mediumBreakPoints}
                                pagination={false}
                                // isRTL={true}
                                itemPadding={[40, 15, 40, 15]}
                                renderArrow={this.noArrow}
                            >
                                {cards}
                            </Carousel>
                        )}
                    </>
                )}
            </div>
        );
    }
}

export default windowSize(Videos);
